import React, { useEffect, useState } from "react";
import ModalShell from "../ModalShell";
import { getMessageForFetchError } from "../../shared/utils/apiError";
import { renameStockBuyRecommendationFilter } from "../../shared/api/stockBuyRecommendationFilters";

export default function StockBuyRecommendationRenameFilterModal({
  open,
  onClose,
  serverUrl,
  stockSession,
  filterId,
  initialName,
  onSaved,
  onError,
}) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setName(String(initialName || ""));
    onError?.("");
  }, [open, initialName, onError]);

  async function save() {
    const trimmed = name.trim();
    if (!trimmed) {
      onError?.("Watchlist name is required.");
      return;
    }
    if (!filterId) {
      onError?.("No watchlist selected.");
      return;
    }

    setSaving(true);
    onError?.("");
    try {
      const data = await renameStockBuyRecommendationFilter(serverUrl, stockSession, {
        filterId,
        name: trimmed,
      });
      await onSaved?.(data);
      onClose?.();
    } catch (err) {
      onError?.(getMessageForFetchError(err));
    } finally {
      setSaving(false);
    }
  }

  return (
    <ModalShell
      open={open}
      onClose={saving ? undefined : onClose}
      title="Rename watchlist"
      subtitle="Update the watchlist name shown on the tab."
      maxWidth={520}
      footer={
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
          <button type="button" className="btn btn-md btn-secondary" disabled={saving} onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-md btn-primary" disabled={saving || !name.trim()} onClick={save}>
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      }
    >
      <label style={{ display: "block" }}>
        <span className="form-label">Name</span>
        <input
          type="text"
          className="form-control"
          value={name}
          maxLength={80}
          onChange={(e) => setName(e.target.value)}
          disabled={saving}
          autoFocus
        />
      </label>
    </ModalShell>
  );
}

